module.exports = __webpack_public_path__ + "static/media/min_red.e61f2eae.png";